import { render, staticRenderFns } from "./autoAddTagEdit.vue?vue&type=template&id=47204ffe&scoped=true"
import script from "./autoAddTagEdit.vue?vue&type=script&lang=js"
export * from "./autoAddTagEdit.vue?vue&type=script&lang=js"
import style0 from "./autoAddTagEdit.vue?vue&type=style&index=0&id=47204ffe&prod&lang=less"
import style1 from "./autoAddTagEdit.vue?vue&type=style&index=1&id=47204ffe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47204ffe",
  null
  
)

export default component.exports